import { render } from "./menus.vue?vue&type=template&id=5b4b04da&scoped=true&ts=true"
import script from "./menus.vue?vue&type=script&lang=ts"
export * from "./menus.vue?vue&type=script&lang=ts"

import "./menus.vue?vue&type=style&index=0&id=5b4b04da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4b04da"]])

export default __exports__